import { forwardRef, useImperativeHandle } from "react";

import { Stack } from "@mui/material";

import { useDisclosure } from "hooks";
import { getPageCount, SHIPMENTS_PAGE_SIZE, sortShipmentsByDate } from "utils";

import { ShipmentsList } from "../ShipmentList";
import { ShipmentsFilter } from "../ShipmentsFilter";

export interface ShipmentListContainerRef {
  closeFilter: VoidFunction;
}

interface Props {
  page: number;
  setPage: (pageNumber: number) => void;
  shipments: CondensedShipment[];
  shipmentsError: string | null;
  shipmentsLoading: boolean;
  shipmentCount: number;
  onFilterExpanded?: VoidFunction;
  onFilterCollapsed?: VoidFunction;
}

// TODO: Refactor this and SupplierShipmentListContainer to use common component due to similarity
export const ShipmentListContainer = forwardRef<
  ShipmentListContainerRef,
  Props
>((props, ref) => {
  const {
    page,
    setPage,
    shipments,
    shipmentsError,
    shipmentsLoading,
    shipmentCount,
    onFilterExpanded,
    onFilterCollapsed,
  } = props;

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleFilterOpen = () => {
    onOpen();
    onFilterExpanded?.();
  };

  const handleFilterClose = () => {
    onClose();
    onFilterCollapsed?.();
  };

  useImperativeHandle(ref, () => ({ closeFilter: handleFilterClose }));

  const pages = getPageCount(shipmentCount, SHIPMENTS_PAGE_SIZE);

  const handlePageChange = (
    _: React.ChangeEvent<unknown>,
    value: number,
  ): void => {
    setPage(value);
  };

  return (
    <Stack spacing={2}>
      <ShipmentsFilter
        isOpen={isOpen}
        onOpen={handleFilterOpen}
        onClose={handleFilterClose}
      />
      <ShipmentsList
        shipments={sortShipmentsByDate(shipments as ShipperCondensedShipment[])}
        error={shipmentsError}
        isLoading={shipmentsLoading}
        page={page}
        pages={pages}
        handlePageSelected={handlePageChange}
      />
    </Stack>
  );
});
